import { AlertCircle, CheckCircle2, Clock, Loader2 } from 'lucide-react';
import type { IngestStatus } from '../../lib/meetingNotesApi';

const STATUS_STYLES: Record<
  IngestStatus,
  { label: string; className: string; icon: typeof Clock; spin?: boolean }
> = {
  PENDING: {
    label: 'În așteptare',
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: Clock,
  },
  PROCESSING: {
    label: 'Se procesează',
    className: 'bg-blue-50 text-blue-700 border-blue-200',
    icon: Loader2,
    spin: true,
  },
  COMPLETED: {
    label: 'Indexat',
    className: 'bg-green-50 text-green-700 border-green-200',
    icon: CheckCircle2,
  },
  FAILED: {
    label: 'Eșuat',
    className: 'bg-red-50 text-red-700 border-red-200',
    icon: AlertCircle,
  },
};

export function IngestStatusBadge({ status }: { status: IngestStatus }) {
  const s = STATUS_STYLES[status] ?? STATUS_STYLES.PENDING;
  const Icon = s.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[11px] font-medium ${s.className}`}
    >
      <Icon size={11} className={s.spin ? 'animate-spin' : undefined} />
      {s.label}
    </span>
  );
}
